import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { APP_ROUTES, DISPATCH_ROLES, REFLEX_ROLES } from '@core/constants';
import { authGuard } from '@core/guards/auth.guard';
import { rolesGuard } from '@core/guards/role.guard';
import { AuthService } from '@core/services/auth.service';
import { SidebarLayout } from '@layout/sidebar-layout/sidebar-layout';
import { NotFound } from '@shared/pages/not-found/not-found';

export const routes: Routes = [
  { path: '', redirectTo: APP_ROUTES.AUTH.LOGIN.path, pathMatch: 'full' },
  {
    path: APP_ROUTES.AUTH.ROOT,
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: APP_ROUTES.SIGN.ROOT,
    loadComponent: () =>
      import('@features/public/delivery-signature/delivery-signature').then(
        (m) => m.DeliverySignature,
      ),
  },
  {
    path: '',
    component: SidebarLayout,
    canActivate: [authGuard],
    children: [
      {
        path: APP_ROUTES.REFLEX.ROOT,
        canActivate: [rolesGuard(REFLEX_ROLES)],
        loadChildren: () => import('@reflex/reflex.routes').then((m) => m.REFLEX_ROUTES),
      },
      { path: '', pathMatch: 'full', redirectTo: () => inject(AuthService).homeUrl() },
      {
        path: APP_ROUTES.DISPATCH.ROOT,
        canActivate: [rolesGuard(DISPATCH_ROLES)],
        loadChildren: () => import('@dispatch/dispatch.routes').then((m) => m.DISPATCH_ROUTES),
      },
      {
        path: 'mantenedores',
        loadChildren: () =>
          import('./features/mantenedores/mantenedores.routes').then((m) => m.MANTENEDORES_ROUTES),
      },
      {
        path: APP_ROUTES.NOT_FOUND.ROOT,
        component: NotFound,
      },
    ],
  },
  { path: '**', redirectTo: APP_ROUTES.AUTH.LOGIN.path },
];
